import React, { JSX, SyntheticEvent } from "react";
import "./Card.css";
import { CompanySearch } from "../../company";
import AddPortfolio from "../Portfolio/AddPortfolio/AddPortfolio";
import { Link } from "react-router-dom";
import { symbolName } from "typescript";

interface Props {
  id: string;
  searchResult: CompanySearch;
  onPortfolioCreate: (e: SyntheticEvent) => void;
}

const Card: React.FC<Props> = ({ id, searchResult, onPortfolioCreate }: Props): JSX.Element => {
  return (
    <div
      className="flex flex-col items-center justify-between w-full p-6 bg-slate-100 rounded-lg md:flex-row"
      key={id}
      id={id}
    >
      <img src="/moneyUp.png" alt="company logo" className="w-1/6 max-w-[80px] object-contain" />

      <Link
        to={`/company/${searchResult.symbol}`}
        className="font-bold text-center text-veryDarkViolet md:text-left"
      >
        {searchResult.name} ({searchResult.symbol})
      </Link>
      <p className="text-veryDarkBlue">${searchResult.currency}</p>

      <p className="font-bold text-veryDarkBlue">
        {searchResult.exchange} - {searchResult.exchangeFullName}
      </p>
      <AddPortfolio
        onPortfolioCreate={onPortfolioCreate}
        symbol={searchResult.symbol}
        stockFullName={searchResult.name}
      />
    </div>
  );
};

export default Card;
